export default "__VITE_ASSET__l_H6ztFN__"